<template>
  <div>
    <Header>Driver List</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mt-3 mb-3 text-left p-3 bg-gray-100 rounded-md !shadow relative">
        <AdvancedSearchForm
          v-model="filters"
          :listName="'driver'"
          :searchInput="searchInput"
          @filtersUpdated="onFiltersUpdated"
          :searchbarListOverride="searchbarList"
        />
      </div>
      <div class="flex relative justify-center items-center mt-4" v-if="drivers.length > 0">
        <Button v-if="canSubmitNew"
          :color="'blue'"
          :size="'md'"
          class="new-driver-button absolute-right rounded-md !shadow m-1"
          @click="toDriverForm()">
          New Driver
        </Button>
        <Pagination :pages="pages" to="/DriverList" />
      </div>
      <Spinner
        v-if="driversLoading"
        message="Loading Drivers"
        :size="16"
      />
      <Table class="relative left-[calc(-40vw+50%)] w-[80vw]">
        <template #columns>
          <th
            v-for="(column, index) in columns"
            :key="index"
            scope="col"
            class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider"
          >
            <Sort v-if="column.sortable"
              class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider"
              :key="index"
              :name="column.name"
              :outlined="false"
              :selectedSort="selectedSort"
              @setSelectedSort="selectedSort = $event"
            >
              {{ column.text }}
            </Sort>
            <div v-else>
              {{ column.text }}
            </div>
          </th>
        </template>
        <template #rows>
          <DriverItem
            v-for="(driver, index) in drivers"
            :key="index"
            :driver="driver"
            :showInternalData="showInternalData"
            @validateDriver="validateDriver(driver.user.id)"
            @activateDriver="activateDriver(driver.user.id)"
            @resendEmail="resendEmail(driver.user.id)"
          />
        </template>
      </Table>
      <div class="flex justify-center pb-4">
        <Pagination :pages="pages" to="/DriverList" />
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
.new-driver-button {
  position: absolute;
  right: 0;
  color: #616060;
  font-size: 14px;
  margin-top: 5px;
}
</style>

<script>
import driverListService from '../services/pages/driverList.js'

import view from '../services/user/view.js'
import user from '../services/user/user.js'
import events from '../services/events.js'

import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import Button from '../components/Button.vue'
import Pagination from '../components/Pagination.vue'
import Spinner from '../components/Spinner.vue'
import Table from '../components/Table.vue'
import Sort from '../components/Sort.vue'
import DriverItem from '../components/items/DriverItem.vue'
import AdvancedSearchForm from '../components/Search/AdvancedSearchForm.vue'

import DropdownLists from '../components/DropdownLists.json'
import { omit, isEqual, forOwn } from 'lodash'
import fastDeepEquals from 'fast-deep-equal'

export default {
  components: {
    Header,
    Main,
    Button,
    Pagination,
    Spinner,
    Table,
    Sort,
    DriverItem,
    AdvancedSearchForm,
  },
  data() {
    return {
      user: undefined,
      view: undefined,

      canSubmitNew: false,

      query: {
        search: '',
      },
      filters: [],
      drivers: [],
      totalDrivers: 0,
      driversLoading: false,

      pages: {},
      numPerPage: 50,

      selectedSort: {
        name: '',
        descending: false,
      },
      searchInput: undefined,
      searchbarList: DropdownLists.DriverSearchbarList,
      columns: [
        {
          name: 'user__last_name',
          text: 'Name',
          sortable: true,
        },
        {
          name: 'user__email',
          text: 'Email',
          sortable: false,
        },
        {
          name: 'validated',
          text: 'Validated',
          sortable: true,
        },
        {
          name: 'active',
          text: 'Active',
          sortable: true,
        }
        
      ]
    }
  },
  eventCallbackIds: {},
  methods: {
    async setDriverData() {
      this.view = await view.get()

      this.numPerPage = driverListService.getNumPerPage()

      let apiParams = {
        perPage: this.numPerPage,
        page: this.$route.query.page,
        search: this.query.search,
        sortBy: this.selectedSort.name
          ? ((this.selectedSort.descending ? '-' : '') + this.selectedSort.name)
          : '',
      }

      let driversData
      try {
        this.driversLoading = true
        driversData = (await driverListService.getDriverDataFromServer(apiParams)).data
        this.driversLoading = false
      }
      catch {
        this.driversLoading = false
        return
      }

      this.pages = driversData.pages
      this.drivers = driversData.content
      this.totalDrivers = driversData.page_data.num_drivers
    },
    setQuerySearch(search) {
      if (Object.hasOwn(this.$route.query, 'search')) {
        this.query.search = search
      }
      else {
        delete this.query.search
      }
    },
    setQueryPage(page) {
      if (Object.hasOwn(this.$route.query, 'page')) {
        this.query.page = page
      }
      else {
        delete this.query.page
      }
    },
    updateQueryParams(queryObj) {
      if (!fastDeepEquals(queryObj, this.$route.query)) {
        this.$router.push({
          query: queryObj
        })
        return true
      }
      else {
        return false
      }
    },
    setFiltersQuery() {
      let queryObj = {
        query: {
          ...this.$route.query
        }
      }
      if (this.query.search) {
        queryObj.query.search = this.query.search
      }
      else {
        delete queryObj.query.search
      }


      this.updateQueryParams(queryObj.query)
    },
    setSearchQueryFromQueryParams() {
      forOwn(this.$route.query, (value, key) => {
        switch (key) {
          case 'search':
            this.searchInput = value
            this.setQuerySearch(value)
            break
          case 'page':
            this.setQueryPage(value)
            break
          case 'sortByName':
            this.selectedSort.name = value
            break
          case 'sortByDescending':
            this.selectedSort.descending = value === 'true'
            break
          case 'filters':
            try {
              this.filters = JSON.parse(value)
            } catch {
              this.filters = []
            }
            break
        }
      })
      if (!Object.hasOwn(this.$route.query, 'search')) {
        delete this.query.search
      }
    },
    onFiltersUpdated() {
      if (this.filters.length === 0) {
        delete this.query.search
      }
      else if (this.filters.length === 1) {
        if (!this.filters[0].keyword) {
          delete this.query.search
        }
        else if (this.filters[0].field) {
          this.query.search = JSON.stringify({
            keyword: this.filters[0].keyword,
            field: this.filters[0].field
          })
        }
        else {
          this.query.search = this.filters[0].keyword
        }
      }
      else if (this.filters.length > 1) {
        this.query.search = JSON.stringify(this.filters)
      }
      this.setFiltersQuery()
    },
    onSubmit(submitEvent) {
      submitEvent.preventDefault()
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_driver_list')) {
        if (this.user.can('view_vendor_forms')) {
          this.$router.push({
            name: 'VendorForms'
          })
        }
        else {
          this.$router.push({
            path: '/'
          })
        }
        return true
      }
    },
    toDriverForm() {
      this.$router.push({ name: 'DriverForm' })
    },
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    this.canSubmitNew = this.user.can('submit_new_driver')
    
    if(this.showInternalData){
      this.columns.push(...[
        {
          name: 'user__id',
          text: 'User ID',
          sortable: true,
        },
        {
          name: 'user__auth0_id',
          text: 'Auth0 ID',
          sortable: true,
        },
        {
          name: 'vendor__name',
          text: 'Vendor',
          sortable: true,
        }])
    }
    this.columns.push({
      name: 'actions',
      text: '',
      sortable: false,
    })

    this.$options.eventCallbackIds.listPageSettingsUpdate =
      events.register('listPageSettingsUpdate', (currNumPerPage) => {
      if (this.numPerPage != currNumPerPage) {
        this.setDriverData()
      }
    })
    this.$options.eventCallbackIds.viewUpdated = events.register('viewUpdated', async () => {
      this.setDriverData()
    })

    this.setSearchQueryFromQueryParams()
    this.setDriverData()
  },
  beforeDestroy() {
    events.remove('listPageSettingsUpdate', this.$options.eventCallbackIds.listPageSettingsUpdate)
    events.remove('viewUpdated', this.$options.eventCallbackIds.viewUpdated)
  },
  computed: {
    showInternalData() {
      if (this.user === undefined) {
        return false
      }
      return this.user.can('view_internal_cst_data')
    },
  },
  watch: {
    '$route.query': function () {
      this.setSearchQueryFromQueryParams()
      this.setDriverData()
    },
    selectedSort: {
      handler() {
        let query = omit(this.$route.query, ['sortByName', 'sortByDescending'])
        if (this.selectedSort.name) {
          query.sortByName = this.selectedSort.name
          query.sortByDescending = this.selectedSort.descending
        }
        const queryCompare = {
          ...query,
          sortByDescending: query.sortByDescending ? 'true' : 'false'
        }
        if (!isEqual(this.$route.query, queryCompare)) {
          this.$router.replace({
            query: query
          })
        }
      },
      deep: true
    },
  }
}
</script>